import { API_METHODS } from "../../constant";
export const attrValueApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_ALL_ATTR_VALUE]: () => {
      let urlReq = `/${paramsIn.SubjectId}/AttrValue`;
      return _getAll(urlReq);
    },
    [API_METHODS.GET_ATTR_VALUE]: () => {
      let urlReq = `/${paramsIn.SubjectId}/AttrValue/${paramsIn.id}`;
      return _get(urlReq);
    },
    [API_METHODS.UPDATE_ATTR_VALUE]: () => {
      let urlReq = `/${paramsIn.SubjectId}/AttrValue`;
      return _update(urlReq);
    },
    [API_METHODS.CREATE_ATTR_VALUE]: () => {
      let urlReq = `/${paramsIn.SubjectId}/AttrValue`;
      return _create(urlReq);
    },
    [API_METHODS.DELETE_ATTR_VALUE]: () => {
      let urlReq = `/${paramsIn.SubjectId}/AttrValue/${paramsIn.id}`;
      return _delete(urlReq);
    },
    [API_METHODS.GET_TYPE_ATTR_VALUE]: () => {
      let urlReq = `/${paramsIn.SubjectId}/AttrValue/Attr/${paramsIn.id}`;
      return _get(urlReq);
    }
  };
};
